// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-144[data-v-3aed07fc]{margin-top:144px}.footer-content[data-v-3aed07fc]{width:60%}@media (max-width:1599px){.mt-144[data-v-3aed07fc]{margin-top:75px}}@media (max-width:1023px){.mt-144[data-v-3aed07fc]{margin-top:55px}.footer-content[data-v-3aed07fc]{width:100%}}@media (max-width:767px){.mt-144[data-v-3aed07fc]{margin-top:35px}}", ""]);
// Exports
module.exports = exports;
